/*
 * Copyright (c) 2026. Bolmate B.V.
 */
import './style/bolmateTextarea.scss';

import React, {TextareaHTMLAttributes} from 'react';

import {ErrorType} from '@dvrd/dvr-controls';

import classNames from 'classnames';

import {BolmateControlShape, BolmateControlSize} from '../../../util/types';

import InputController from '../input/inputController';

interface Props {
    onChange: (value: string, evt: React.ChangeEvent) => void;
    value: string;
    label?: string;
    placeholder?: string;
    error?: ErrorType;
    disabled?: boolean;
    autoFocus?: boolean;
    className?: string;
    inputProps?: TextareaHTMLAttributes<any>;
    rows?: number;
    fullWidth?: boolean;
    size?: BolmateControlSize;
    shape?: BolmateControlShape;
    styled?: boolean;
    id?: string;
}

export default function BolmateTextarea(props: Props) {
    const {rows = 6, shape = 'rounded', className, inputProps, ...rest} = props;

    return (
        <InputController
            {...rest}
            area
            shape={shape}
            className={classNames('bolmate-textarea', className)}
            inputProps={{rows, ...inputProps}}
        />
    );
}
